function isBackForwardNavigation() {
  return performance.getEntriesByType("navigation")[0]?.type === 'back_forward';
}

window.addEventListener('pageshow', (event) => {
  if (event.persisted || isBackForwardNavigation()) {
    requestAnimationFrame(() => {
      document.querySelectorAll('.product-card').forEach(card => {
        const form = card.querySelector('.product-variant-form');
        if (!form) return;
  
        const radios = Array.from(form.querySelectorAll('input[name="id"]'));
        if (radios.length === 0) return;
  
        const defaultId = form.dataset.defaultVariantId;
        let targetRadio = radios.find(radio => radio.value === defaultId);
  
        if (!targetRadio) {
          targetRadio = radios[0]; // fallback
        }
  
        radios.forEach(radio => (radio.checked = false));
        targetRadio.checked = true;
  
        targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card').forEach(card => {
    const productId = card.getAttribute('data-product-id');
    const form = card.querySelector('.product-variant-form');
    const priceDisplay = card.querySelector(`#price-display-${productId}`);
    const button = card.querySelector('.product-variant-submit-button');
    const mainImage = card.querySelector(`.js-main-image-${productId}`);
    const ingredient = card.querySelector('.product-card__ingredient');

    if (!form || !mainImage || !button) return;
    if (form.dataset.listenerAttached === 'true') return;
    form.dataset.listenerAttached = 'true';

    let isAddingToCart = false;

    function updateUI() {
      const selected = form.querySelector('input[name="id"]:checked');
      if (!selected) return;

      const price = selected.dataset.price?.split('.')[0];
      const compareAt = selected.dataset.compareAtPrice?.split('.')[0];
      if (priceDisplay) {
        if (compareAt && compareAt !== price) {
          priceDisplay.innerHTML = `${price}<em>${compareAt}</em>`;
        } else {
          priceDisplay.innerHTML = price;
        }
      }

    const label = selected.closest('label');
      if (label?.dataset.variantImage) {
        const newImageUrl = label.dataset.variantImage;

        mainImage.src = newImageUrl;

        const picture = mainImage.closest("picture");
        const mobileSource = picture?.querySelector('source[media*="max-width"]');
        if (mobileSource) {
          mobileSource.srcset = newImageUrl;
        }
      }

      const available = selected.dataset.available === 'true';
      if (!available) {
        button.value = 'Sold Out';
        button.disabled = true;
      } else {
        button.value = 'Add to Cart';
        button.disabled = false;
      }
    }

    form.querySelectorAll('input[name="id"]').forEach(radio => {
      radio.addEventListener('change', updateUI);

      const label = radio.closest('label');
      if (label) {
        label.addEventListener('mouseenter', () => {
          if (label.dataset.variantImage) {
            mainImage.src = label.dataset.variantImage;
          }
        });
        label.addEventListener('mouseleave', () => {
          const selected = form.querySelector('input[name="id"]:checked');
          const selectedLabel = selected?.closest('label');
          if (selectedLabel?.dataset.variantImage) {
            mainImage.src = selectedLabel.dataset.variantImage;
          }
        });
      }
    });

    // NOTE: `initializeUI()`는 제거했습니다.

    // 장바구니 추가
    button.addEventListener('click', async () => {
      if (isAddingToCart) return;

      const selected = form.querySelector('input[name="id"]:checked');
      if (!selected || selected.dataset.available !== 'true') return;

      isAddingToCart = true;
      button.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: selected.value, quantity: 1 }),
        });

        if (!res.ok) throw new Error('Add to cart failed');

        const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
        const sections = await sectionsRes.json();

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer?.renderContents) {
          cartDrawer.renderContents({ id: selected.value, sections });
          cartDrawer.classList.add('is-open');
        }
      } catch (err) {
        console.error('Cart Error:', err);
      } finally {
        isAddingToCart = false;
        button.disabled = false;
      }
    });

    // 질감 이미지 호버 효과
    if (ingredient) {
      const thumbnail = card.querySelector('.product-card__thumbnail');
      if (thumbnail) {
        thumbnail.addEventListener('mouseenter', () => {
          ingredient.style.opacity = '1';
          mainImage.style.opacity = '0';
        });
        thumbnail.addEventListener('mouseleave', () => {
          ingredient.style.opacity = '0';
          mainImage.style.opacity = '1';
        });
      }
    }

    function addVariantToLink(link) {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('/products/')) return;

      link.addEventListener('click', e => {
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected) return;

        e.preventDefault();

        const variantId = selected.value;
        const url = new URL(href, window.location.origin);
        url.searchParams.set('variant', variantId);
        window.location.href = url.toString();
      });
    }

    const thumbnailLink = card.querySelector('.product-card__thumbnail');
    if (thumbnailLink) addVariantToLink(thumbnailLink);
    form.querySelectorAll('a').forEach(addVariantToLink);
  });
});

/* PLP 용량표기버튼 swiper 
=====================================*/
document.addEventListener('DOMContentLoaded', () => {
	// 설정값 (유지보수 용이)
	const MOBILE_BREAKPOINT = 1024;
	const MIN_SLIDES_FOR_SWIPER = 3;
	
	// 모바일 체크 함수
	const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;
	
	const productListSwiper = () => {
		const productListSwiperElements = document.querySelectorAll('.product-variant-swiper');
		
		if (productListSwiperElements.length === 0) return;
		
			// 현재 모바일 상태 확인
			const currentIsMobile = isMobile();
			
			productListSwiperElements.forEach(swiperElement => {
				// 기존 Swiper 인스턴스가 있다면 제거
				if (swiperElement.swiper) {
					swiperElement.swiper.destroy(true, true);
				}
				
				// swiper-slide 개수 확인
				const slideElements = swiperElement.querySelectorAll('.swiper-slide');
				const hasEnoughSlides = slideElements.length >= MIN_SLIDES_FOR_SWIPER;
				
				// 해당 swiper의 컨테이너에서 navigation 버튼 찾기
				const container = swiperElement.closest('.product-variant-swiper-container');
				const nextButton = container.querySelector('.swiper-button-next');
				const prevButton = container.querySelector('.swiper-button-prev');
				
				if (currentIsMobile && hasEnoughSlides) {
          // 모바일: navigation 버튼 표시 및 swiper 초기화
          if (nextButton) nextButton.style.display = 'block';
          if (prevButton) prevButton.style.display = 'block';
          
          // 새로운 Swiper 인스턴스 생성 (모바일에서만)
          const swiper = new Swiper(swiperElement, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            nested: true,
            breakpoints: {
              320: {
                spaceBetween: 4,
              }
            },
            navigation: {
              nextEl: nextButton,
              prevEl: prevButton,
            },
            loop: false,
            speed: 600,
            grabCursor: true,
            touchRatio: 1,
            touchAngle: 45,
            resistance: true,
            resistanceRatio: 0.85,
            // 커스텀 클래스명으로 충돌 방지
            // wrapperClass: 'product-variant-swiper-wrapper',
            // slideClass: 'product-variant-swiper-slide',
          });
				} else {
					// 데스크톱 또는 slide가 3개 미만: navigation 버튼 숨김
					if (nextButton) nextButton.style.display = 'none';
					if (prevButton) prevButton.style.display = 'none';
				}
		});
	}

	// 디바운싱으로 리사이즈 처리 (300ms 딜레이)
	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(productListSwiper, 300);
	}, { passive: true });

	document.addEventListener('shopify:section:load', productListSwiper);
	productListSwiper();

});
